(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('click',(event)=>{const close=event.target.closest('[data-close-details]');if(close)close.closest('details[open]')?.removeAttribute('open');});
(() => {
  const hoverQuery = window.matchMedia('(min-width: 1360px) and (hover: hover) and (pointer: fine)');
  if (!hoverQuery.matches) return;
  const items = Array.from(document.querySelectorAll('.desktop-nav__item'));
  items.forEach((item) => {
    const summary = item.querySelector(':scope > summary');
    item.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse') return;
      items.forEach((other) => { if (other !== item) other.removeAttribute('open'); });
      item.setAttribute('open', '');
    });
    item.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'mouse') item.removeAttribute('open');
    });
    if (summary) summary.addEventListener('click', (event) => {
      if (!hoverQuery.matches) return;
      event.preventDefault();
      item.setAttribute('open', '');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journey-grid"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('.journey').forEach((section) => {
    if (section.dataset.solutionExpandReady === 'true') return;
    section.dataset.solutionExpandReady = 'true';
    const resultPanel = section.querySelector('.journey__results');
    const cards = Array.from(section.querySelectorAll('.journey-card__details'));
    if (!resultPanel || !cards.length) return;
    cards.forEach((details) => {
      const summary = details.querySelector('.journey-card__summary');
      const template = details.querySelector('.journey-card__product-template');
      if (!summary || !template) return;
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        const wasActive = summary.getAttribute('aria-expanded') === 'true';
        cards.forEach((other) => {
          other.removeAttribute('open');
          other.querySelector('.journey-card__summary')?.setAttribute('aria-expanded', 'false');
        });
        if (wasActive) {
          resultPanel.hidden = true;
          resultPanel.replaceChildren();
          return;
        }
        summary.setAttribute('aria-expanded', 'true');
        details.setAttribute('open', '');
        resultPanel.replaceChildren(template.content.cloneNode(true));
        resultPanel.hidden = false;
        if (window.matchMedia('(max-width: 749px)').matches) {
          resultPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    const sort = event.target.closest('[data-sort-form] select');
    if (!sort) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    window.location.assign(url.toString());
  });
  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-close-details]');
    if (close) close.closest('details[open]')?.removeAttribute('open');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-planter-pilot"]) return;
  try {
    
if (!customElements.get('planter-pilot-info')) {
  customElements.define('planter-pilot-info', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.product = JSON.parse(this.querySelector('[data-product-json]').textContent);
      this.config = JSON.parse(this.querySelector('[data-pilot-config-map]').textContent);
      this.words = JSON.parse(this.querySelector('[data-pilot-words]').textContent);
      this.form = this.querySelector('form[action*="/cart/add"]');
      this.submit = this.form?.querySelector('[name="add"]');
      this.sticky = this.querySelector('[data-pdp-sticky]');
      this.stickySubmit = this.querySelector('[data-sticky-submit]');
      if (!this.form || !this.submit) return;
      const mapped = this.product.variants.filter(v => {
        const c = this.config[String(v.id)];
        return c && typeof c.enabled === 'boolean' && c.pack && c.stored === v.options[2];
      });
      this.variants = mapped.filter(v => this.config[String(v.id)].enabled && this.config[String(v.id)].size);
      const tuples = this.variants.map(v => JSON.stringify(this.tuple(v)));
      this.mappingComplete = mapped.length === this.product.variants.length && new Set(tuples).size === tuples.length;
      this.querySelectorAll('[data-option-position]').forEach(input => input.addEventListener('change', event => this.onOptionEvent(event), { signal }));
      this.querySelectorAll('[data-gallery-thumb]').forEach(button => button.addEventListener('click', () => this.showMedia(button.dataset.galleryThumb, this.state), { signal }));
      this.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => this.stepMedia(Number(button.dataset.galleryStep), this.state), { signal }));
      this.form.addEventListener('submit', event => {
        const variant = this.resolve();
        if (this.submitting || !this.canBuy(variant)) { event.preventDefault(); return; }
        this.form.querySelector('[name="id"]').value = variant.id;
        this.submitting = true;
        this.form.setAttribute('aria-busy', 'true');
        this.submit.disabled = true;
        this.querySelector('[data-add-to-cart-text]').textContent = this.submit.dataset.loading;
        if (this.stickySubmit) { this.stickySubmit.disabled = true; this.stickySubmit.textContent = this.submit.dataset.loading; }
      }, { signal });
      const stage = this.querySelector('.product-gallery__stage');
      stage?.addEventListener('pointerdown', event => { if (event.button === 0) this.swipeStart = { x: event.clientX, y: event.clientY, transaction: this.state }; }, { signal });
      stage?.addEventListener('pointerup', event => {
        if (!this.swipeStart) return;
        const transaction = this.swipeStart.transaction;
        const dx = event.clientX - this.swipeStart.x, dy = event.clientY - this.swipeStart.y;
        this.swipeStart = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.stepMedia(dx < 0 ? 1 : -1, transaction);
      }, { signal });
      stage?.addEventListener('pointercancel', () => { this.swipeStart = null; }, { signal });
      this.initialize();
      window.addEventListener('pageshow', () => this.resumeSelection(), { signal });
      this.observer = new IntersectionObserver(() => this.updateSticky());
      this.observer.observe(this.submit);
      window.addEventListener('resize', () => this.updateSticky(), { signal });
      window.addEventListener('scroll', () => this.updateSticky(), { passive: true, signal });
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.revision = (this.revision || 0) + 1; this.pendingTransaction = null; this.swipeStart = null; }
    tuple(variant) {
      const c = this.config[String(variant.id)];
      return [variant.options[0], variant.options[1], c.size, c.pack];
    }
    selectedOptions() { return this.state ? [...this.state.selection] : [null, null, null, null]; }
    resolve() { return this.state?.variant || null; }
    canBuy(variant) { return !!(this.isCurrent(this.state) && variant === this.state.variant && this.mappingComplete && variant?.available && this.config[String(variant.id)]?.enabled && this.config[String(variant.id)]?.approved); }
    isCurrent(transaction) { return !!transaction && transaction === this.state && transaction.revision === this.revision; }
    initialize() {
      // Reconnection/page restoration must never seed an old default over a newer choice.
      if (this.state) { this.resumeSelection(); return; }
      const requested = new URL(window.location.href).searchParams.get('variant');
      const id = requested || this.dataset.initialVariant;
      const variant = this.variants.find(v => String(v.id) === String(id));
      const transaction = this.beginSelection(variant ? this.tuple(variant) : [null, null, null, null]);
      this.commitSelection(transaction, false);
    }
    resumeSelection() {
      this.submitting = false;
      this.form?.removeAttribute('aria-busy');
      if (!this.state) { this.initialize(); return; }
      const latestSelection = this.pendingTransaction?.revision === this.revision ? this.pendingTransaction.selection : this.state.selection;
      this.commitSelection(this.beginSelection(latestSelection));
    }
    resolveSelection(previous) {
      const selected = [...previous];
      for (let index = 0; index < 4; index++) {
        const prefix = selected.slice(0, index);
        const candidates = prefix.every(Boolean) ? this.variants.filter(v => prefix.every((value, i) => this.tuple(v)[i] === value)) : [];
        const values = [...new Set(candidates.map(v => this.tuple(v)[index]))];
        if (!values.includes(selected[index])) selected[index] = index > 0 && values.length === 1 ? values[0] : null;
        if (!selected[index]) { selected.fill(null, index); break; }
      }
      return selected;
    }
    beginSelection(previous, expectedRevision = this.revision || 0) {
      if (expectedRevision !== (this.revision || 0)) return null;
      const selection = Object.freeze(this.resolveSelection(previous));
      const matches = selection.every(Boolean) ? this.variants.filter(v => this.tuple(v).every((value, i) => value === selection[i])) : [];
      const variant = matches.length === 1 ? matches[0] : null;
      const revision = this.revision = (this.revision || 0) + 1;
      this.pendingTransaction = Object.freeze({ revision, selection, variant, option3: variant ? this.config[String(variant.id)].stored : null });
      return this.pendingTransaction;
    }
    commitSelection(transaction, updateUrl = true) {
      if (!transaction || transaction !== this.pendingTransaction || transaction.revision !== this.revision) return false;
      this.state = transaction;
      this.pendingTransaction = null;
      this.projectControls(transaction);
      this.updateAvailabilityMatrix(transaction);
      this.updateVariant(transaction, updateUrl);
      return true;
    }
    projectControls(transaction) {
      if (!this.isCurrent(transaction)) return;
      this.querySelectorAll('[data-option-position]').forEach(input => {
        input.checked = input.value === transaction.selection[Number(input.dataset.optionPosition) - 1];
      });
    }
    onOptionEvent(event) {
      const input = event.currentTarget;
      const position = Number(input.dataset.optionPosition);
      if (!input.checked || input.disabled || input.closest('.variant-value').hidden || (event.timeStamp && event.timeStamp < (this.lastOptionEventTime || 0))) { this.projectControls(this.state); return; }
      this.lastOptionEventTime = event.timeStamp || this.lastOptionEventTime || 0;
      this.onOptionChange(position, input.value);
    }
    onOptionChange(position, value, expectedRevision = this.revision || 0) {
      if (expectedRevision !== (this.revision || 0) || !Number.isInteger(position) || position < 1 || position > 4) return false;
      const selected = this.pendingTransaction?.revision === this.revision ? [...this.pendingTransaction.selection] : this.selectedOptions();
      const prefix = selected.slice(0, position - 1).concat(value);
      if (!prefix.every(Boolean) || !this.variants.some(v => prefix.every((item, i) => this.tuple(v)[i] === item))) return false;
      selected[position - 1] = value;
      return this.commitSelection(this.beginSelection(selected, expectedRevision));
    }
    updateAvailabilityMatrix(transaction) {
      if (!this.isCurrent(transaction)) return;
      const selected = transaction.selection;
      this.querySelectorAll('[data-option-position]').forEach(input => {
        const index = Number(input.dataset.optionPosition) - 1;
        const prefix = selected.slice(0, index).concat(input.value);
        const ready = prefix.every(Boolean);
        const matches = ready ? this.variants.filter(v => prefix.every((value, i) => this.tuple(v)[i] === value)) : [];
        const label = input.closest('.variant-value');
        input.disabled = !ready || !matches.length;
        label.hidden = ready && !matches.length;
        const note = label.querySelector('[data-choice-note]');
        const status = !ready ? this.words.choosePrevious : !matches.length ? this.words.unavailable : matches.every(v => !this.config[String(v.id)].approved) ? this.words.previewPending : matches.every(v => !v.available) ? this.words.soldOut : '';
        label.dataset.choiceState = status === this.words.previewPending ? 'media-pending' : input.disabled ? 'unavailable' : 'available';
        if (note) { note.textContent = ''; note.hidden = true; }
        input.setAttribute('aria-label', [input.value, status].filter(Boolean).join(' — '));
        if (index === 0) {
          const candidates = matches.filter(v => input.value !== selected[0] || selected.every((value, i) => !value || this.tuple(v)[i] === value));
          const preview = candidates.find(v => this.config[String(v.id)].approved);
          const img = label.querySelector('[data-style-image]');
          const placeholder = label.querySelector('[data-style-placeholder]');
          if (img) { img.hidden = !preview; if (preview) img.src = this.config[String(preview.id)].thumb; }
          if (placeholder) placeholder.hidden = !!preview;
        }
      });
    }
    updateVariant(transaction, updateUrl = true) {
      if (!this.isCurrent(transaction)) return;
      const variant = transaction.variant;
      const selected = transaction.selection;
      const c = variant ? this.config[String(variant.id)] : null;
      const missing = selected.findIndex(value => !value);
      const choose = missing >= 0 ? this.words.choose + ' ' + this.words.labels[missing].toLowerCase() : this.words.unavailable;
      const status = !this.mappingComplete ? this.words.unavailable : !variant ? choose : !c.approved ? this.words.previewPending : variant.available ? this.submit.dataset.available : this.words.soldOut;
      const id = this.form.querySelector('[name="id"]');
      id.value = variant ? variant.id : '';
      id.disabled = !this.canBuy(variant);
      this.submit.disabled = !this.canBuy(variant) || this.submitting;
      this.querySelector('[data-add-to-cart-text]').textContent = status;
      if (this.stickySubmit) { this.stickySubmit.disabled = this.submit.disabled; this.stickySubmit.textContent = status; }
      const availability = this.querySelector('[data-availability]');
      if (availability) availability.textContent = this.canBuy(variant) ? availability.dataset.available : status;
      this.querySelectorAll('[data-option-selected]').forEach(label => { label.textContent = selected[Number(label.dataset.optionSelected) - 1] || this.words.choose; });
      const summary = selected.map((value, index) => this.words.labels[index] + ': ' + (value || this.words.choose)).join('\n');
      this.querySelectorAll('[data-selected-configuration]').forEach(label => { label.textContent = summary; });
      this.querySelectorAll('[data-sticky-configuration]').forEach(label => { label.textContent = selected.filter(Boolean).join(' · '); });
      const included = c ? (c.pack === 'Set of 2' ? this.words.setIncluded : this.words.singleIncluded) : this.words.choosePack;
      const sizeCandidates = selected.slice(0, 3).every(Boolean) ? this.variants.filter(v => this.tuple(v).slice(0, 3).every((value, i) => value === selected[i])) : [];
      const exactValues = [...new Set(sizeCandidates.map(v => this.config[String(v.id)].assembled))];
      const exact = exactValues.length === 1 && exactValues[0] ? exactValues[0] : null;
      const dimensions = c?.assembled || exact || (c || selected[2] ? this.words.dimensionsPending : this.words.chooseSize);
      this.querySelectorAll('[data-pack-copy]').forEach(el => { el.textContent = included; });
      this.querySelectorAll('[data-exact-dimensions]').forEach(el => { el.textContent = dimensions; });

      this.querySelectorAll('[data-size-copy]').forEach(el => { el.hidden = !exact; el.textContent = exact ? this.words.exactDimensions + ' ' + exact : ''; });
      const previewNote = this.querySelector('[data-preview-note]');
      if (previewNote) previewNote.hidden = !selected[0] || !this.variants.some(v => v.options[0] === selected[0] && !this.config[String(v.id)].approved);
      document.querySelectorAll('[data-planter-selection-fact="included"]').forEach(el => { el.textContent = included; });
      document.querySelectorAll('[data-planter-selection-fact="dimensions"]').forEach(el => { el.textContent = dimensions; });
      const quantityLabel = this.querySelector('[data-quantity-context]');
      if (quantityLabel) quantityLabel.textContent = c?.pack === 'Set of 2' ? this.words.numberSets : this.words.numberUnits;
      const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency }).format(amount / 100);
      const price = this.querySelector('[data-product-price]'), wrapper = price?.closest('[data-price-wrapper]');
      if (wrapper) wrapper.hidden = !variant;
      const priceSlot = this.querySelector('[data-price-slot]');
      if (priceSlot) priceSlot.hidden = !variant;
      if (price) price.textContent = variant ? money(variant.price) : '';
      const stickyPrice = this.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = variant ? money(variant.price) : '';
      let compare = this.querySelector('[data-product-compare-price]');
      if (!compare && wrapper && variant?.compare_at_price > variant?.price) { compare = document.createElement('s'); compare.setAttribute('data-product-compare-price', ''); wrapper.append(compare); }
      if (compare) { compare.hidden = !variant || !(variant.compare_at_price > variant.price); compare.textContent = !compare.hidden ? money(variant.compare_at_price) : ''; }
      const notice = this.querySelector('[data-selection-notice]');
      if (notice) notice.textContent = [selected.filter(Boolean).join(' · '), variant ? money(variant.price) : choose, this.canBuy(variant) ? '' : status].filter(Boolean).join('. ');
      this.filterGallery(transaction);
      if (!this.isCurrent(transaction)) return;
      if (updateUrl) { const url = new URL(window.location.href); if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant'); window.history.replaceState({}, '', url.toString()); }
      this.updateSticky();
    }
    filterGallery(transaction) {
      if (!this.isCurrent(transaction)) return;
      const variant = transaction.variant;
      const c = variant ? this.config[String(variant.id)] : null;
      const ids = c?.approved ? c.media.map(String).filter(Boolean) : [];
      const slides = [...this.querySelectorAll('[data-media-id]')];
      const valid = ids.filter(id => slides.some(slide => slide.dataset.mediaId === id));
      slides.forEach(slide => { slide.dataset.galleryIncluded = String(valid.includes(slide.dataset.mediaId)); slide.hidden = true; });
      this.querySelectorAll('[data-gallery-thumb]').forEach(button => { button.hidden = !valid.includes(button.dataset.galleryThumb); });
      const placeholder = this.querySelector('[data-gallery-placeholder]');
      if (placeholder) { placeholder.hidden = valid.length > 0; placeholder.textContent = variant ? this.words.imagePending : this.words.chooseImage; }
      const controls = this.querySelector('.product-gallery__controls');
      if (controls) controls.hidden = !valid.length;
      const count = this.querySelector('[data-gallery-total]');
      if (count) count.textContent = valid.length;
      if (valid.length) this.showMedia(valid[0], transaction);
    }
    stepMedia(step, transaction = this.state) {
      if (!this.isCurrent(transaction)) return;
      const slides = [...this.querySelectorAll('[data-media-id]')].filter(slide => slide.dataset.galleryIncluded === 'true');
      const target = slides[slides.findIndex(slide => !slide.hidden) + step];
      if (target) this.showMedia(target.dataset.mediaId, transaction);
    }
    showMedia(id, transaction) {
      if (!this.isCurrent(transaction)) return;
      const slides = [...this.querySelectorAll('[data-media-id]')].filter(slide => slide.dataset.galleryIncluded === 'true');
      const target = slides.find(slide => slide.dataset.mediaId === String(id));
      if (!target) return;
      slides.forEach(slide => { slide.hidden = slide !== target; if (slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause()); });
      this.querySelectorAll('[data-gallery-thumb]').forEach(button => button.setAttribute('aria-current', String(button.dataset.galleryThumb === String(id))));
      const index = slides.indexOf(target), count = this.querySelector('[data-gallery-current]');
      if (count) count.textContent = index + 1;
      this.querySelectorAll('[data-gallery-step]').forEach(button => { button.disabled = Number(button.dataset.galleryStep) < 0 ? index === 0 : index === slides.length - 1; });
    }
    updateSticky() {
      if (this.sticky && this.submit) this.sticky.hidden = !window.matchMedia('(max-width: 749px)').matches || this.submit.getBoundingClientRect().bottom >= 0;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('product-info')) {
    customElements.define('product-info', class extends HTMLElement {
      connectedCallback() {
        this.product = JSON.parse(this.querySelector('[data-product-json]').textContent);
        const manifestNode = this.querySelector('[data-media-manifest]');
        try {
          this.mediaManifest = manifestNode && manifestNode.textContent.trim() ? JSON.parse(manifestNode.textContent) : null;
        } catch (error) {
          this.mediaManifest = null;
        }
        this.form = this.querySelector('form[action*="/cart/add"]');
        this.cartFeedback = this.querySelector('[data-cart-feedback]');
        this.stickyAtc = this.querySelector('[data-sticky-atc]');
        this.stickySubmit = this.querySelector('[data-sticky-atc-submit]');
        this.stickyNudge = this.querySelector('[data-sticky-atc-nudge]');
        this.stickyTab = this.querySelector('[data-sticky-atc-tab]');
        this.stickyDismiss = this.querySelector('[data-sticky-atc-dismiss]');
        this.stickyManuallyCollapsed = false;
        this.stickyAutoShown = false;
        this.stickyCollapseTimer = null;
        this.stickyShowTimer = null;
        this.stickyEvaluationFrame = null;
        this.stickyMutationObserver = null;
        this.stickyTriggerReady = false;
        this.footerSection = null;
        this.footerNewsletter = null;
        this.footerVisible = false;
        this.stickyCompleteLookSections = [];
        this.cartFeedbackTimer = null;
        const requestedVariantId = new URLSearchParams(window.location.search).get('variant');
        const requestedVariant = requestedVariantId
          ? this.product.variants.find((variant) => String(variant.id) === String(requestedVariantId))
          : null;
        this.directVariantId = requestedVariant ? String(requestedVariant.id) : null;
        this.directSoldOut = Boolean(requestedVariant && !requestedVariant.available);
        this.querySelectorAll('[data-option-position]').forEach((input) => input.addEventListener('change', () => this.onOptionChange()));
        this.lastSelectedOptions = this.selectedOptions();
        const initialVariant = this.product.variants.find((variant) => variant.options.every((value, index) => value === this.selectedOptions()[index]));
        this.currentVariant = initialVariant || null;
        if (this.form) this.form.addEventListener('submit', (event) => this.addToCart(event));
        if (this.stickySubmit) this.stickySubmit.addEventListener('click', () => {
          if (this.currentVariant && this.currentVariant.available && this.form) this.form.requestSubmit();
        });
        if (this.stickyTab) this.stickyTab.addEventListener('click', () => this.expandStickyAtc(true));
        if (this.stickyDismiss) this.stickyDismiss.addEventListener('click', () => this.collapseStickyAtc(true));
        this.setupStickyAtc();
        this.updateStickyAtc(this.currentVariant);
        this.updateAvailabilityMatrix();
        if (this.dataset.bambooUx === 'true') this.updateBambooInterface(this.currentVariant);
      }

      disconnectedCallback() {
        if (this.stickyScrollHandler) {
          window.removeEventListener('scroll', this.stickyScrollHandler);
          window.removeEventListener('resize', this.stickyScrollHandler);
        }
        if (this.stickyObserver) this.stickyObserver.disconnect();
        if (this.stickyMutationObserver) this.stickyMutationObserver.disconnect();
        window.clearTimeout(this.stickyCollapseTimer);
        window.clearTimeout(this.stickyShowTimer);
        window.clearTimeout(this.cartFeedbackTimer);
        if (this.stickyEvaluationFrame) {
          const cancel = window.cancelAnimationFrame || window.clearTimeout;
          cancel(this.stickyEvaluationFrame);
          this.stickyEvaluationFrame = null;
        }
        this.syncMobileFloatingState(false);
      }

      selectedOptions() {
        return [...this.querySelectorAll('[data-option-position]:checked')].sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((input) => input.value);
      }

      onOptionChange() {
        // Keep the chosen option value, then resolve the closest purchasable variant.
        // This lets shoppers move between valid size/color groups without getting
        // trapped by a non-existent cross-combination (for example, 47-inch White).
        const previous = this.lastSelectedOptions || [];
        let selected = this.selectedOptions();
        const changedIndex = selected.findIndex((value, index) => value !== previous[index]);
        let changedOption = changedIndex >= 0 ? String(this.product.options[changedIndex] || '').toLowerCase() : null;

        this.directSoldOut = false;
        this.directVariantId = null;

        let variant = this.product.variants.find((item) => item.options.every((value, index) => value === selected[index]));
        let autoCorrected = false;

        if (this.dataset.bambooUx !== 'true' && changedIndex >= 0 && (!variant || !variant.available)) {
          const changedValue = selected[changedIndex];
          const matchingOptions = this.product.variants.filter((item) => item.options[changedIndex] === changedValue);
          const inStockOptions = matchingOptions.filter((item) => item.available);
          const candidates = (inStockOptions.length ? inStockOptions : matchingOptions)
            .sort((a, b) => {
              const score = (candidate) => candidate.options.reduce((total, value, index) => {
                return index === changedIndex ? total : total + (value === selected[index] ? 1 : 0);
              }, 0);
              return score(b) - score(a);
            });

          if (candidates.length) {
            variant = candidates[0];
            this.querySelectorAll('[data-option-position]').forEach((input) => {
              const optionIndex = Number(input.dataset.optionPosition) - 1;
              input.checked = variant.options[optionIndex] === input.value;
            });
            selected = [...variant.options];
            autoCorrected = true;
          }
        }

        // If a size click also changed the color to a valid stocked option,
        // tell the gallery to prioritize that color's hero image.
        if (autoCorrected) {
          const colorIndex = this.product.options.findIndex((name) => String(name).toLowerCase().includes('color'));
          if (colorIndex >= 0 && previous[colorIndex] !== selected[colorIndex]) changedOption = 'color';
        }

        this.lastSelectedOptions = selected;
        this.querySelectorAll('[data-option-selected]').forEach((label) => {
          const input = this.querySelector(`[data-option-position="${label.dataset.optionSelected}"]:checked`);
          if (input) label.textContent = input.value;
        });

        this.updateVariant(variant, changedOption);
        this.updateAvailabilityMatrix();
        if (this.dataset.bambooUx === 'true') this.updateBambooInterface(variant);
      }
      updateVariant(variant, changedOption) {
        const submit = this.querySelector('[name="add"]');
        const text = this.querySelector('[data-add-to-cart-text]');
        const availability = this.querySelector('[data-availability]');
        const practicalVariantLabel = this.querySelector('[data-practical-variant-title]');
        if (!variant) {
          if (practicalVariantLabel) practicalVariantLabel.textContent = '';
          this.currentVariant = null;
          this.form.querySelector('[name="id"]').value = '';
          submit.disabled = true;
          text.textContent = submit.dataset.unavailable || 'Unavailable';
          if (availability) availability.textContent = availability.dataset.unavailable || submit.dataset.unavailable || 'Unavailable';
          this.updateStickyAtc(null);
          return;
        }
        this.currentVariant = variant;
        this.querySelectorAll('[data-sofa-configuration]').forEach((panel) => {
          panel.hidden = panel.dataset.sofaConfiguration !== String(variant.id);
        });
        if (practicalVariantLabel) {
          practicalVariantLabel.textContent = variant.title && variant.title !== 'Default Title'
            ? variant.title : '';
        }
        this.form.querySelector('[name="id"]').value = variant.id;
        submit.disabled = !variant.available;
        text.textContent = variant.available ? (submit.dataset.available || 'Add to cart') : (submit.dataset.soldOut || 'Sold out');
        if (availability) {
          availability.textContent = variant.available ? availability.dataset.available : availability.dataset.soldOut;
        }
        const price = this.querySelector('[data-product-price]');
        if (price) price.textContent = new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: this.dataset.currency }).format(variant.price / 100);
        const compare = this.querySelector('[data-product-compare-price]');
        if (compare) compare.textContent = variant.compare_at_price ? new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: this.dataset.currency }).format(variant.compare_at_price / 100) : '';
        this.updateStickyAtc(variant);
        window.history.replaceState({}, '', `${this.dataset.productUrl}?variant=${variant.id}`);
        this.dispatchEvent(new CustomEvent('lirago:variant-change', {
          detail: { variant, changedOption, initial: false }
        }));
      }

      setupStickyAtc() {
        if (!this.stickyAtc) return;
        this.purchaseBlock = this.querySelector('.product-main__purchase');
        this.belowFoldSection = document.querySelector('.product-main__below-fold');
        this.footerSection = document.querySelector('footer.site-footer, .site-footer, footer');
        this.footerNewsletter = document.querySelector('.site-footer__newsletter');
        if (!this.purchaseBlock) return;
        this.primaryPurchaseVisible = true;
        this.stickyAtc.hidden = true;
        this.stickyScrollHandler = () => this.queueStickyEvaluation();
        window.addEventListener('scroll', this.stickyScrollHandler, { passive: true });
        window.addEventListener('resize', this.stickyScrollHandler, { passive: true });
        if ('IntersectionObserver' in window) {
          this.stickyObserver = new IntersectionObserver(() => this.queueStickyEvaluation(), { threshold: [0, 0.01, 1] });
          this.stickyObserver.observe(this.purchaseBlock);
          if (this.belowFoldSection) this.stickyObserver.observe(this.belowFoldSection);
          if (this.footerSection) this.stickyObserver.observe(this.footerSection);
          if (this.footerNewsletter) this.stickyObserver.observe(this.footerNewsletter);
        }
        if ('MutationObserver' in window && !this.stickyMutationObserver) {
          this.stickyMutationObserver = new MutationObserver(() => {
            this.queueStickyEvaluation();
          });
          this.stickyMutationObserver.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
        }
        this.evaluateStickyTrigger();
      }

      queueStickyEvaluation() {
        if (this.stickyEvaluationFrame) return;
        const schedule = window.requestAnimationFrame || ((callback) => window.setTimeout(callback, 0));
        this.stickyEvaluationFrame = schedule(() => {
          this.stickyEvaluationFrame = null;
          this.evaluateStickyTrigger();
        });
      }

      isMobileStickyViewport() {
        return Boolean(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
      }

      resolveDesktopStickySections() {
        this.stickyCompleteLookSections = [...document.querySelectorAll('.related-products-recommendations, .related-products')];
      }

      isAnyStickySectionVisible(sections) {
        return sections.some((section) => {
          const rect = section && section.getBoundingClientRect();
          return Boolean(rect && rect.top < window.innerHeight && rect.bottom > 0);
        });
      }

      syncMobileFloatingState(visible) {
        if (!document.body) return;
        document.body.classList.toggle('pdp-mobile-sticky-visible', Boolean(visible && this.isMobileStickyViewport()));
      }

      evaluateStickyTrigger() {
        if (!this.purchaseBlock) return;
        this.resolveDesktopStickySections();
        // The product component can connect before the global footer is parsed.
        // Resolve late-loaded footer sentinels on every evaluation so the
        // terminal-page guard cannot be skipped on the first scroll.
        if (!this.footerSection) {
          this.footerSection = document.querySelector('footer.site-footer, .site-footer, footer');
          if (this.footerSection && this.stickyObserver) this.stickyObserver.observe(this.footerSection);
        }
        if (!this.footerNewsletter) {
          this.footerNewsletter = document.querySelector('.site-footer__newsletter');
          if (this.footerNewsletter && this.stickyObserver) this.stickyObserver.observe(this.footerNewsletter);
        }
        const rect = this.purchaseBlock.getBoundingClientRect();
        const purchaseVisible = rect.bottom > 0 && rect.top < window.innerHeight;
        const footerRect = this.footerSection && this.footerSection.getBoundingClientRect();
        const newsletterRect = this.footerNewsletter && this.footerNewsletter.getBoundingClientRect();
        const footerVisible = Boolean(footerRect && footerRect.top < window.innerHeight && footerRect.bottom > 0);
        const newsletterVisible = Boolean(newsletterRect && newsletterRect.top < window.innerHeight && newsletterRect.bottom > 0);
        const desktopViewport = !this.isMobileStickyViewport();
        const desktopCompleteLookVisible = desktopViewport && this.isAnyStickySectionVisible(this.stickyCompleteLookSections);
        this.primaryPurchaseVisible = purchaseVisible;
        this.footerVisible = footerVisible || newsletterVisible;
        if (footerVisible || newsletterVisible || desktopCompleteLookVisible) {
          this.stickyTriggerReady = false;
          this.hideStickyAtc();
          return;
        }
        if (this.isMobileStickyViewport()) {
          this.stickyTriggerReady = !purchaseVisible && !footerVisible;
          this.updateStickyAtc(this.currentVariant);
          return;
        }
        const belowFoldRect = this.belowFoldSection && this.belowFoldSection.getBoundingClientRect();
        const belowPurchaseVisible = Boolean(belowFoldRect && belowFoldRect.top < window.innerHeight);
        this.stickyTriggerReady = belowPurchaseVisible;
        this.updateStickyAtc(this.currentVariant);
      }

      updateStickyAtc(variant) {
        if (!this.stickyAtc) return;
        const feedbackVisible = Boolean(this.cartFeedback && !this.cartFeedback.hidden);
        const canShow = Boolean(variant && variant.available && this.stickyTriggerReady && !this.footerVisible && !feedbackVisible);
        if (!canShow) this.hideStickyAtc();
        else if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) this.showMobileStickyAtc();
        else if (!this.stickyAutoShown && !this.stickyManuallyCollapsed) {
          if (!this.stickyShowTimer) {
            this.stickyShowTimer = window.setTimeout(() => {
              this.stickyShowTimer = null;
              this.expandStickyAtc(false);
            }, 350);
          }
        } else this.collapseStickyAtc(false);
        if (this.stickySubmit) this.stickySubmit.disabled = !variant || !variant.available;
        const variantLabel = this.stickyAtc.querySelector('[data-sticky-atc-variant]');
        const priceLabel = this.stickyAtc.querySelector('[data-sticky-atc-price]');
        if (variantLabel) variantLabel.textContent = variant && variant.title && variant.title !== 'Default Title' ? variant.title : '';
        if (priceLabel && variant) priceLabel.textContent = new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: this.dataset.currency }).format(variant.price / 100);
      }

      expandStickyAtc(manual) {
        if (!this.stickyAtc || !this.currentVariant || !this.currentVariant.available || !this.stickyTriggerReady) return;
        window.clearTimeout(this.stickyCollapseTimer);
        window.clearTimeout(this.stickyShowTimer);
        this.stickyAtc.hidden = false;
        this.stickyAtc.classList.remove('is-collapsed');
        if (this.stickyNudge) this.stickyNudge.hidden = false;
        if (this.stickyTab) this.stickyTab.hidden = true;
        if (manual) this.stickyManuallyCollapsed = false;
        if (!manual && !this.stickyAutoShown) {
          this.stickyAutoShown = true;
          this.stickyCollapseTimer = window.setTimeout(() => this.collapseStickyAtc(false), 4200);
        }
      }

      collapseStickyAtc(manual) {
        if (!this.stickyAtc) return;
        window.clearTimeout(this.stickyCollapseTimer);
        window.clearTimeout(this.stickyShowTimer);
        if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
          this.hideStickyAtc();
          return;
        }
        if (!this.currentVariant || !this.currentVariant.available || !this.stickyTriggerReady) {
          this.hideStickyAtc();
          return;
        }
        this.stickyAtc.hidden = false;
        this.stickyAtc.classList.add('is-collapsed');
        if (this.stickyNudge) this.stickyNudge.hidden = false;
        if (this.stickyTab) this.stickyTab.hidden = false;
        if (manual) this.stickyManuallyCollapsed = true;
      }

      showMobileStickyAtc() {
        if (!this.stickyAtc || !this.currentVariant || !this.currentVariant.available || !this.stickyTriggerReady) return;
        window.clearTimeout(this.stickyCollapseTimer);
        window.clearTimeout(this.stickyShowTimer);
        this.stickyAtc.hidden = false;
        this.stickyAtc.classList.remove('is-collapsed');
        if (this.stickyNudge) this.stickyNudge.hidden = false;
        if (this.stickyTab) this.stickyTab.hidden = true;
        this.syncMobileFloatingState(true);
      }

      hideStickyAtc() {
        if (!this.stickyAtc) return;
        window.clearTimeout(this.stickyCollapseTimer);
        window.clearTimeout(this.stickyShowTimer);
        this.stickyAtc.hidden = true;
        this.stickyAtc.classList.remove('is-collapsed');
        if (this.stickyNudge) this.stickyNudge.hidden = true;
        if (this.stickyTab) this.stickyTab.hidden = true;
        this.syncMobileFloatingState(false);
      }

      async addToCart(event) {
        event.preventDefault();
        const variant = this.currentVariant;
        const submit = this.querySelector('.product-form__submit');
        if (!variant || !variant.available || !this.form || !submit) return;
        const text = this.querySelector('[data-add-to-cart-text]');
        const originalText = text ? text.textContent : '';
        submit.disabled = true;
        if (text) text.textContent = 'Adding…';
        try {
          const action = this.form.action.endsWith('.js') ? this.form.action : `${this.form.action}.js`;
          const response = await fetch(action, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(this.form) });
          const item = await response.json();
          if (!response.ok) throw new Error(item.description || item.message || 'Unable to add this item.');
          this.showCartFeedback(item, variant);
        } catch (error) {
          this.showCartFeedbackMessage(error.message || 'Unable to add this item.', true, 3200);
        } finally {
          submit.disabled = !this.currentVariant || !this.currentVariant.available;
          if (text) text.textContent = this.currentVariant && this.currentVariant.available ? originalText : (submit.dataset.soldOut || 'Sold out');
        }
      }

      showCartFeedback(item, variant) {
        this.showCartFeedbackMessage('✓ Added to cart', false, 2400);
      }

      showCartFeedbackMessage(message, isError, duration) {
        if (!this.cartFeedback) return;
        window.clearTimeout(this.cartFeedbackTimer);
        this.cartFeedback.hidden = false;
        this.cartFeedback.classList.toggle('is-error', Boolean(isError));
        this.hideStickyAtc();
        const title = this.cartFeedback.querySelector('[data-cart-feedback-title]');
        if (title) title.textContent = message;
        this.cartFeedbackTimer = window.setTimeout(() => {
          if (!this.cartFeedback) return;
          this.cartFeedback.hidden = true;
          this.cartFeedback.classList.remove('is-error');
          this.updateStickyAtc(this.currentVariant);
        }, duration);
      }


      // Bamboo Leaf PDP pilot: never hide a real color or size. Keep missing
      // combinations visible but disabled, and sold-out variants selectable.
      updateBambooInterface(variant) {
        if (this.dataset.bambooUx !== 'true') return;
        const selected = this.selectedOptions();
        const sizeIndex = this.product.options.findIndex((name) => String(name).toLowerCase().includes('size'));
        const colorIndex = this.product.options.findIndex((name) => String(name).toLowerCase().includes('color'));
        const size = sizeIndex >= 0 ? selected[sizeIndex] : '';
        const color = colorIndex >= 0 ? selected[colorIndex] : '';
        const pack = this.dataset.productUrl.includes('set-of-2') ? 'set' : 'single';
        const summary = this.querySelector('[data-bamboo-selection-summary] strong');
        if (summary) {
          summary.textContent = [size, color, pack === 'set' ? 'Set of 2 (2 complete screens)' : 'Single Screen (1 complete screen)'].filter(Boolean).join(' · ');
        }
        const normalizeSize = (value) => String(value || '').toLowerCase().replace(/×/g, 'x').replace(/["\s]/g, '').replace(/[wh]/g, '');
        const formatMoney = (amount) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency', currency: this.dataset.currency || 'USD'
        }).format(Number(amount) / 100);
        ['single', 'set'].forEach((key) => {
          const card = this.querySelector('[data-bamboo-pack="' + key + '"]');
          const script = this.querySelector('[data-bamboo-family-' + key + ']');
          if (!card || !script) return;
          let targetProduct = null;
          try { targetProduct = JSON.parse(script.textContent); } catch (error) { return; }
          if (!targetProduct || !Array.isArray(targetProduct.variants)) return;
          const options = targetProduct.options || [];
          const targetSize = options.findIndex((name) => String(name).toLowerCase().includes('size'));
          const targetColor = options.findIndex((name) => String(name).toLowerCase().includes('color'));
          const variants = targetProduct.variants;
          const exact = variants.find((item) =>
            (targetSize < 0 || normalizeSize(item.options[targetSize]) === normalizeSize(size)) &&
            (targetColor < 0 || String(item.options[targetColor]).toLowerCase() === String(color).toLowerCase())
          );
          const usableExact = exact && exact.available;
          const sameSize = variants.find((item) => item.available && (targetSize < 0 || normalizeSize(item.options[targetSize]) === normalizeSize(size)));
          const fallback = sameSize || variants.find((item) => item.available) || exact || variants[0];
          const target = key === pack && variant ? variant : usableExact ? exact : fallback;
          const text = card.querySelector('[data-bamboo-pack-price]');
          const hint = card.querySelector('[data-bamboo-pack-hint]');
          const url = card.dataset.bambooProductUrl || this.dataset.productUrl;
          if (target) {
            card.href = url + '?variant=' + target.id;
            if (text) {
              text.textContent = formatMoney(target.price) + (key === 'set' ? ' · ' + formatMoney(Math.round(target.price / 2)) + ' / screen' : '');
            }
          }
          if (hint) {
            hint.textContent = !target || !target.available
              ? 'Currently sold out'
              : key === pack || usableExact
                ? 'Same size and color'
                : 'Other option: ' + (targetColor >= 0 ? String(target.options[targetColor] || '') : '') + (targetSize >= 0 ? ' · ' + String(target.options[targetSize] || '') : '');
          }
          card.classList.toggle('bamboo-pack-card--alternative', key !== pack && !usableExact);
          card.classList.toggle('bamboo-pack-card--sold-out', !target || !target.available);
          card.setAttribute('aria-label', (key === 'set' ? 'Set of 2 screens' : 'Single screen') + '. ' + (text ? text.textContent : '') + '. ' + (hint ? hint.textContent : ''));
        });
      }

      updateAvailabilityMatrix() {
        const selected = this.selectedOptions();
        const soldOutText = this.querySelector('[name="add"]').dataset.soldOut || 'Sold out';
        if (this.dataset.bambooUx === 'true') {
          this.querySelectorAll('[data-option-position]').forEach((input) => {
            const candidate = [...selected];
            candidate[Number(input.dataset.optionPosition) - 1] = input.value;
            const matches = this.product.variants.filter((item) => item.options.every((value, index) => value === candidate[index]));
            const exists = matches.length > 0;
            const inStock = matches.some((item) => item.available);
            const label = input.closest('.variant-value');
            const state = !exists ? 'not-offered' : inStock ? 'available' : 'sold-out';
            const status = label && label.querySelector('[data-bamboo-status]');
            if (label) {
              label.hidden = false;
              label.dataset.bambooState = state;
              label.classList.toggle('is-sold-out', exists && !inStock);
              label.classList.toggle('is-unavailable', !exists);
              label.removeAttribute('aria-hidden');
              label.title = (input.getAttribute('aria-label') || input.value) + (state === 'sold-out' ? ' — Out of stock' : state === 'not-offered' ? ' — Not offered with current selection' : '');
            }
            if (status) status.textContent = state === 'sold-out' ? 'Out of stock' : state === 'not-offered' ? 'Not offered' : '';
            input.disabled = !exists;
            input.setAttribute('aria-disabled', String(!exists));
          });
          return;
        }
        this.querySelectorAll('[data-option-position]').forEach((input) => {
          const optionIndex = Number(input.dataset.optionPosition) - 1;
          const matchingVariants = this.product.variants.filter((variant) => variant.options[optionIndex] === input.value);
          const variantExists = matchingVariants.length > 0;
          const variantAvailable = matchingVariants.some((variant) => variant.available);
          const isDirectSoldOutSelection = Boolean(
            this.directSoldOut &&
            input.checked &&
            matchingVariants.some((variant) => String(variant.id) === String(this.directVariantId) && !variant.available)
          );
          // Display every actually offered option value, including sold-out colors.
          // Changing to a sold-out value selects its real variant and disables Add to Cart.
          // Do not create impossible size/color combinations.
          const shouldShow = variantExists;
          const soldOut = variantExists && !variantAvailable;
          const valueControl = input.closest('.variant-value');
          if (valueControl) {
            valueControl.hidden = !shouldShow;
            valueControl.classList.toggle('is-sold-out', soldOut);
            valueControl.classList.toggle('is-unavailable', !variantExists);
            valueControl.setAttribute('aria-hidden', String(!shouldShow));
            valueControl.setAttribute('aria-label', `${input.getAttribute('aria-label') || input.value}${soldOut ? ` — ${soldOutText}` : ''}`);
            valueControl.title = soldOut ? `${input.value} — ${soldOutText}` : '';
          }
          input.disabled = !variantExists;
          input.setAttribute('aria-disabled', String(!variantExists));
        });
      }

    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const state = window.LiragoRecommendationState || { claimed: new Set() };
    if (!(state.claimed instanceof Set)) state.claimed = new Set();
    window.LiragoRecommendationState = state;

    document.querySelectorAll('product-recommendations[data-recommendation-intent]').forEach((section) => {
      if (section.dataset.recommendationLoaded === 'true') return;
      section.dataset.recommendationLoaded = 'true';

      const url = section.dataset.url;
      if (!url) return;

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then((response) => {
          if (!response.ok) throw new Error('Recommendation request failed');
          return response.text();
        })
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const incoming = Array.from(html.querySelectorAll('product-recommendations')).find((node) => node.dataset.recommendationIntent === section.dataset.recommendationIntent);
          if (!incoming) return;

          const claimed = new Set(state.claimed);
          incoming.querySelectorAll('[data-recommendation-product-id]').forEach((item) => {
            const id = item.dataset.recommendationProductId;
            if (!id || id === section.dataset.productId || claimed.has(id)) {
              item.remove();
            } else {
              claimed.add(id);
            }
          });

          const grid = incoming.querySelector('.related-products__grid');
          if (!grid || !grid.querySelector('[data-recommendation-product-id]')) return;
          section.innerHTML = incoming.innerHTML;
          section.classList.add('is-loaded');
          state.claimed = claimed;
        })
        .catch(() => {
          section.dataset.recommendationLoaded = 'false';
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-this-look"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCompleteLook = () => {
      document.querySelectorAll('[data-shop-this-look]').forEach((section) => {
        if (section.dataset.completeLookReady === 'true') return;
        section.dataset.completeLookReady = 'true';
        section.querySelectorAll('[data-complete-look-form]').forEach((form) => {
          const submit = form.querySelector('[data-complete-look-submit]');
          const error = form.querySelector('[data-complete-look-error]');
          form.addEventListener('submit', async (event) => {
            event.preventDefault();
            if (!submit || submit.disabled) return;
            const items = [...form.querySelectorAll('[data-look-line-id]')].map((field) => ({ id: Number(field.value), quantity: Number(field.dataset.lookQuantity) }));
            if (!items.length || items.some((item) => !Number.isInteger(item.id) || item.id < 1 || !Number.isInteger(item.quantity) || item.quantity < 1)) return;
            submit.disabled = true;
            submit.setAttribute('aria-busy', 'true');
            if (error) error.hidden = true;
            try {
              const response = await fetch(section.dataset.cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
              if (!response.ok) throw new Error('cart_add_failed');
              window.location.assign(section.dataset.cartUrl);
            } catch (requestError) {
              submit.removeAttribute('aria-busy');
              submit.disabled = false;
              if (error) { error.textContent = section.dataset.cartErrorLabel; error.hidden = false; }
            }
          });
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeCompleteLook, { once: true }); else initializeCompleteLook();
    document.addEventListener('shopify:section:load', initializeCompleteLook);
  })();

  } catch(e) { console.error(e); }
})();
})();
